<mat-card class="overflow-hidden breadcrumb-appearance">
  <div>
    <div class="row">
      <div class="col-lg-3 col-sm-3">
        <h4 class="page-title m-0 f-s-18 f-w-500">
          {{ pageInfo?.['title'] }}
        </h4>
        <div class="d-flex align-items-center overflow-hidden justify-content-start list-style-none m-t-8">
          <ng-template ngFor let-url [ngForOf]="pageInfo?.['urls']" let-last="last">
            <li class="breadcrumb-item" *ngIf="!last" [routerLink]="url.url">
              <a [routerLink]="url.url" class="text-primary">{{ url.title }}</a>
            </li>
            <li class="breadcrumb-item active" *ngIf="last">{{ url.title }}</li>
          </ng-template>
        </div>
      </div>
      <div
        class="bg-white px-3 py-2 m-3 right-side col-lg-9 col-sm-9 text-right position-relative align-items-center justify-content-end gap-20 d-none d-sm-flex">
        <!-- Inserire qui il broadcumb destro -->
        <ng-container *ngIf="isFilterRoute()">
          <app-page-filters [type]="filterType" />
        </ng-container>
      </div>
    </div>
  </div>
</mat-card>